import React from 'react';

/**
 * Schlichtes, eigenständiges Layout für die öffentlichen Rechtstexte
 * (Datenschutz, Nutzungsbedingungen). Ohne Login, ohne Sidebar.
 */
export default function LegalLayout({ title, updated, children }) {
    return (
        <div className="min-h-screen bg-background text-foreground">
            <div className="max-w-3xl mx-auto px-5 py-12">
                <a href="/" className="text-sm text-primary hover:opacity-80">&larr; Zurück zur Anmeldung</a>
                <h1 className="text-3xl font-semibold tracking-tight mt-4 mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    {title}
                </h1>
                {updated && <p className="text-sm text-muted-foreground mb-8">Stand: {updated}</p>}
                <div className="prose-legal space-y-5 text-[15px] leading-relaxed text-foreground/90">
                    {children}
                </div>
            </div>
        </div>
    );
}

export function Section({ heading, children }) {
    return (
        <section>
            <h2 className="text-lg font-semibold mt-8 mb-2 text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>
                {heading}
            </h2>
            <div className="space-y-2 text-muted-foreground">{children}</div>
        </section>
    );
}
